import React from "react";
import ReactDOM from "react-dom";
import { IntlProvider } from "react-intl";
import { OidcProvider } from 'redux-oidc';
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "./business/redux";
import { messages, language } from './translations'
import userManager from "./business/oidc/userManager";
import Router from "./ui/router/Router";
import 'antd/dist/antd.css';
import { loadUser } from 'redux-oidc';
import { processSilentRenew } from 'redux-oidc';
import { ThemeProvider } from "styled-components";
import { theme } from "./ui/theme/theme";

loadUser(store, userManager);

const Application = (
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
      <IntlProvider locale={language} messages={messages[language]}>
        <Router/>
      </IntlProvider>
      </OidcProvider>
    </Provider>
  </ThemeProvider>
);

if (window.location.pathname === '/silent_renew') {
  processSilentRenew();
} else {
  ReactDOM.render(Application, document.getElementById("root"));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
